import { render, staticRenderFns } from "./TeamOverviewTeam.vue?vue&type=template&id=3a87f9e4&scoped=true"
import script from "./TeamOverviewTeam.vue?vue&type=script&lang=js"
export * from "./TeamOverviewTeam.vue?vue&type=script&lang=js"
import style0 from "./TeamOverviewTeam.vue?vue&type=style&index=0&id=3a87f9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a87f9e4",
  null
  
)

export default component.exports